import { useTranslation } from "react-i18next";
import { GetProjectResponse, ProjectExtraWorkAgreementApprovalStatusRequest, usePutApiProjectsByProjectIdExtraworkagreementsAndExtraWorkAgreementIdMutation } from "api/generatedApi";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { ExtraWorkAgreementFormData } from "./use-input-validation";

interface Props {
  project: GetProjectResponse;
  agreementId: string;
  onSuccess: () => void;
}

export function useUpdateExtraWorkAgreement(props: Props) {
  const { project, agreementId, onSuccess } = props;
  const { t } = useTranslation();
  const [updateExtraWorkAgreement] = usePutApiProjectsByProjectIdExtraworkagreementsAndExtraWorkAgreementIdMutation();

  const wrapMutation = useMutation({
    onSuccess: () => {
      onSuccess();
    },
    successProps: {
      description: t("dashboard.extraWorkAgreements.update.success.description"),
    },
    errorProps: {
      description: t("dashboard.extraWorkAgreements.update.error.description"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  return async (data: ExtraWorkAgreementFormData) => {
    await wrapMutation(
      updateExtraWorkAgreement({
        projectId: project?.id ?? "",
        extraWorkAgreementId: agreementId,
        updateProjectExtraWorkAgreementsRequest: {
          description: data.description,
          extraWorkAgreementNumber: data.extraWorkAgreementNumber,
          extraWorkAgreementType: data.extraWorkAgreementType,
          name: data.name,
          paymentDkr: data.paymentDkr,
          workTime: data.workTime,
          approvalStatus: data.approvalStatus as ProjectExtraWorkAgreementApprovalStatusRequest,
        },
      })
    );
  };
}
